/* eslint-disable */
import React from 'react'
import { Box, Flex } from 'grid-styled'
import { connect } from 'react-redux'
import { reset, reduxForm, formValueSelector } from 'redux-form'
import _ from 'lodash'

import { fetchActivationForPartners, saveManageInf } from 'alelo-logic/actions'
import { getVehiclesCategory } from '../../../alelo-logic/services/activationService'
import { showModal } from '../../modules/ModalRoot/actions'
import { startSaving, stopSaving } from '../../modules/form-state-actions'
import image from '../../../static/confirmation.png'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

import ImersiveHeader from '../../elements/ImersiveHeader'
import Content from '../../../styles/objects/Content'
import { SimpleModal } from 'app/elements/Modal'
import { blueGray } from 'styles/settings/colors'

import Option from '../../elements/Option'
import Button from 'app/elements/Button'
import IcClose from '../../elements/Icon/ic-close'

import ManageInfoModal from 'app/modules/ManageInfoModal'

import imageError from '../../../static/contestacao.png'

import { AxisField, PlateField, ConfirmPlateField, IdentifierField } from './form-fields'

import {
  Title,
  Paragraph,
  TextInfo,
  List,
  BoxGrey,
  ListForm,
  TitleSecond,
  WrapperPill,
  Pill,
  Back,
  Form
} from './styles'

import {
  labels,
  titleModal,
  title,
  paragraph,
  textInfo,
  mandatoryInfo,
  titleModalError,
  modalDescriptionError
} from './data.json'

import IcCar from '../../elements/Icon/ic-car'
import IcUtility from '../../elements/Icon/ic-utility'
import IcTruck from '../../elements/Icon/ic-truck'
import IcBus from '../../elements/Icon/ic-bus'

class Activation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selected: 'carro-passeio',
      axis: [],
      modalIsOpen: false,
      manageInfo: {
        informacao1: null,
        informacao2: null,
        informacao3: null
      }
    }
  }

  setOption = selected => {
    this.setState({ selected }, () => {
      const { selected } = this.state

      if (selected === 'caminhao' || selected === 'onibus') this.getCategory(selected)
    })
  }

  componentDidMount() {
    // this.props.dispatchReset()
    // console.log(this.refs.form)
    // const { querySelectorAll: formSelector = null } = this.refs.form || {};
    // const firstInput = formSelector && formSelector('input')[0];
    // firstInput && firstInput.focus();
    // console.log('firstInput',  firstInput)
    if (window && window.document && window.document.getElementById("inputPlate") )
      window.document.getElementById("inputPlate").focus()
      // document.querySelectorAll('input')
      // window.document.querySelectorAll('input')[1].focus()
  }

  getCategory = selected => {
    getVehiclesCategory(selected).then(response => {
      const optionCategory = response.map(item => {
        return Object.assign(
          {},
          {
            value: item.id,
            label: item.descricao
          }
        )
      })
      this.setState({ axis: optionCategory })
    })
  }

  handleSubmit = values => {
    const { selected, manageInfo } = this.state
    const { accountPlans = {}, setIdentifiers = null, next = false } = this.props
    const { plans = [], activePlanId } = accountPlans
    const currentPlan = plans.find(plan => String(plan.id) === String(activePlanId)) || {}
    const { accountId, plan = {} } = currentPlan

    const formatValues = Object.assign({ typeCar: selected }, values, {
      accountId,
      type: plan.type
    })

    const data = Object.values(manageInfo).map(item => {
      if (item != null) {
        item.codIdentificador = formatValues.identifier
        item.conta = formatValues.accountId
        item.placa = formatValues.plate

        return item
      }
    })

    this.props.fetchActivation(formatValues, next)
  }

  toggleModal = () => {
    this.setState({ modalIsOpen: !this.state.modalIsOpen })
  }

  handleCloseModal = () => {
    this.setState({ modalType: 'chooseEdit', informationSelected: null, msgError: '' })
    this.props.toggleModal()
  }

  render() {
    const { selected, axis, modalIsOpen } = this.state
    const { fieldPlate, fieldConfirmPlate, fieldIdentifier, saving, toggleModal } = this.props
    const showAxios = selected === 'caminhao' || selected === 'onibus'

    return (
      <SimpleModal hideModal={toggleModal} maxWidth={924}>
        <Box>
          <Content>
            <Title>{title}</Title>
          </Content>

          {/* <BoxGrey> */}
            <Content>
              <TextInfo>{textInfo}</TextInfo>
              <List>
                <Option
                  active={selected === 'carro-passeio'}
                  description="Carro de passeio"
                  icon={<IcCar />}
                  setOption={this.setOption}
                  value="carro-passeio"
                />
                <Option
                  active={selected === 'carro-utilitario'}
                  description="Carro utilitário"
                  icon={<IcUtility />}
                  setOption={this.setOption}
                  value="carro-utilitario"
                />
                <Option
                  active={selected === 'caminhao'}
                  description="Caminhão"
                  icon={<IcTruck />}
                  setOption={this.setOption}
                  value="caminhao"
                />
                <Option
                  active={selected === 'onibus'}
                  description="Ônibus"
                  icon={<IcBus />}
                  setOption={this.setOption}
                  value="onibus"
                />
              </List>

              <Form onSubmit={this.props.handleSubmit(this.handleSubmit)} ref="form">
                <ListForm>
                  <Box width={1} mb={1}>
                    <PlateField autoFocus={true} id="inputPlate" />
                  </Box>
                  <Box width={1} mb={1}>
                    <ConfirmPlateField id="inputConfirmPlate" />
                  </Box>
                  {showAxios && (
                    <Box width={1} mb={1} id="selectAxis">
                      <AxisField axis={axis} />
                    </Box>
                  )}
                  <Box width={1} mb={1}>
                    <IdentifierField disabled />
                  </Box>
                </ListForm>

                <Flex align="center" justify="flex-start" mt={[0, '0px']}>
                  <Button
                    text={labels.submitButton}
                    type="submit"
                    loading={saving}
                    width="200px"
                    disabled={saving || (!fieldPlate || !fieldConfirmPlate || !fieldIdentifier || selected === '')}
                  />
                </Flex>
              </Form>
            </Content>
          {/* </BoxGrey> */}
          {modalIsOpen ? (
            <ManageInfoModal
              isOpen={modalIsOpen}
              toggleModal={this.toggleModal}
              modalStart="include"
              match={this.props.match}
              controlled
              handleSubmitExternal={values => this.addManageInf(values)}
            />
          ) : null}
        </Box>
        <Back onClick={this.handleCloseModal}>
          <IcClose width={24} height={24} fill={blueGray} />
        </Back>
      </SimpleModal>
    )
  }
}

export const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector('activationForm')
  return {
    fieldPlate: selector(state, 'plate'),
    fieldConfirmPlate: selector(state, 'confirmPlate'),
    fieldIdentifier: selector(state, 'identifier'),
    saving: state.reducer.formState.saving,
    accountPlans: state.reducer.accountPlans,
    initialValues: {
      identifier: ownProps.numberVeloeTag
    }
  }
}

export const mapDispatchToProps = (dispatch, ownProps) => ({
  initFormState: () => dispatch(stopSaving()),
  dispatchReset: () => {
    dispatch(reset('activationForm'))
  },
  fetchActivation: (values, next) => {
    dispatch(startSaving())
    dispatch(fetchActivationForPartners(values))
      .then(async resp => {
        dispatch(stopSaving())
        ownProps.setIdentifiers(resp)
        ownProps.toggleModal()
        if (next) {
          ownProps.toggleQRCode(true)
        }
      })
      .catch(e => {
        dispatch(stopSaving())
        dispatch(
          showModal(CONFIRM_UPDATE, {
            modalTitle: titleModalError,
            modalDescription: modalDescriptionError,
            image: imageError
          })
        )
      })
  }
})

const form = reduxForm({
  form: 'activationForm',
  destroyOnUnmount: true
})(Activation)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/app/pages/ActivationForPartner/index.js